
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import userService from './a1/user/user-service';
import { GetCurrentUserResponse } from './a1/user/user-models';
import storeService from './services/store-service';

@Options({
  components: {
  },
})
export default class App extends Vue {

  async created() {
    try {
      const currentUser: GetCurrentUserResponse = await userService.current();
      if (currentUser?.username) {
        storeService.setUser(currentUser);
      }
    } catch (error) {
      // Ignored
    }
  }

  get isAuthenticated() {
    return store.getters.isAuthenticated;
  }

  get username() {
    return store.getters.username;
  }

  get isMenuOpen(): boolean {
    return store.getters.isMenuOpen;
  }

  get isInHomeRoute() {
    return this.$route.name === 'home';
  }

  get isInStudyRoute() {
    return this.$route.name === 'study';
  }

  get isInStudyPrsRoute() {
    return this.$route.name === 'study-prs';
  }

  get isInReviewRoute() {
    return this.$route.name === 'review';
  }

  get isInWordsRoute() {
    return this.$route.name === 'words';
  }

  get isInTopicsRoute() {
    return this.$route.name === 'topics';
  }
}
